import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import { LazyDiv } from 'components/common/LazyHtml'
import withBreadPayments from 'components/common/BreadPayments/withBreadPayments'
import withBreadPaymentBatchProcessing from 'components/common/BreadPayments/withBreadPaymentBatchProcessing'

export default compose(
  withType({ type: 'BOTCreditCardTeaser' }),
  withBreadPayments,
  withBreadPaymentBatchProcessing
)(LazyDiv)
